import { Component, Input, OnInit } from '@angular/core';
import { BlockScreenService } from '@shared/services/block-screen.service';

@Component({
  selector: 'app-block-screen',
  templateUrl: './block-screen.component.html',
  styleUrls: ['./block-screen.component.scss'],
})
export class BlockScreenComponent implements OnInit {
  @Input() mostrar: boolean = true;
  @Input() mensaje: string = 'Cargando';
  @Input() mensajeExtra: string = 'Espere un momento...';
  @Input() autoClose: boolean = true; // Se cierra automáticamente luego de N segundos
  @Input() autoCloseSeconds: number = 5;

  constructor(private blockScreenService: BlockScreenService) {
    this.setautoClose();
  }

  ngOnInit() {
    // this.checkVisibility();
  }

  open() {
    this.mostrar = true;
    this.blockScreenService.showBlockScreen.next(true);
  }

  close() {
    this.mostrar = false;
    this.blockScreenService.showBlockScreen.next(false);
  }

  setautoClose() {
    this.blockScreenService.showBlockScreen.subscribe((resp) => {
      console.log(this.blockScreenService.autoCloseBlockScreen, resp);
      if (this.blockScreenService.autoCloseBlockScreen && resp) {
        setTimeout(() => {
          console.log('cerrandoVentana');
          this.close();
        }, this.autoCloseSeconds * 1000);
      }
    });
  }

  checkVisibility() {
    setTimeout(() => {
      const box = document.querySelector('.fullscreen-centrado');
      if (box !== null) {
        const rect = box.getBoundingClientRect();
        const isInViewport =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth);

        console.log(isInViewport);
      }
    }, 2000);
  }
}
